<head>
    <title>Admin Reports</title>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
        crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb></app-breadcrumb>
<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="row">
    <div class="col-md-6">

    </div>
    <div class="col-md-6">
        <div class="row">
            <div class="col-md-4">
                <div class="d-flex gap-2 align-items-center report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'Default'}"
                    (click)="moreAdminReportDetails('Default')" (keydown.enter)="moreAdminReportDetails('Default')">
                    <div class="reports_block">
                        <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
                    </div>
                    <p class="report_subtext">Default</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="d-flex gap-2 align-items-center  report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'Login Failed Attempts'}"
                    (click)="moreAdminReportDetails('Login Failed Attempts')"
                    (keydown.enter)="moreAdminReportDetails('Login Failed Attempts')" style=" cursor: pointer;">
                    <div class="reports_block">
                        <img src="../../assets/img/user (3).png" width="16px" height="16px" alt="Login Failed Attempts">
                    </div>
                    <p class="report_subtext">Login Failed Attempts</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="d-flex gap-2 align-items-center report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User Password Changes'}"
                    (click)="moreAdminReportDetails('User Password Changes')"
                    (keydown.enter)="moreAdminReportDetails('User Password Changes')" style=" cursor: pointer;">
                    <div class="reports_block">
                        <img src="../../assets/img/reset-password (1).png" width="16px" height="16px"
                            alt="User Password Changes">
                    </div>
                    <p class="report_subtext">User Password Changes</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="d-flex gap-2 align-items-center report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User vs Functional Roles Privilege'}"
                    (click)="moreAdminReportDetails('User vs Functional Roles Privilege')"
                    (keydown.enter)="moreAdminReportDetails('User vs Functional Roles Privilege')"
                    style=" cursor: pointer;">
                    <div class="reports_block">
                        <img src="../../assets/img/functions.png" width="16px" height="16px"
                            alt="User vs Functional Roles Privilege">
                    </div>
                    <p class="report_subtext">User vs Functional Roles Privilege</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="d-flex gap-2 align-items-center report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User vs RM'}"
                    (click)="moreAdminReportDetails('User vs RM')"
                    (keydown.enter)="moreAdminReportDetails('User vs RM')" style=" cursor: pointer;">
                    <div class="reports_block">
                        <img src="../../assets/img/versus (1).png" width="16px" height="16px" alt="User vs RM">
                    </div>
                    <p class="report_subtext">User vs RM</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="d-flex gap-2 align-items-center report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User vs Activity'}"
                    (click)="moreAdminReportDetails('User vs Activity')"
                    (keydown.enter)="moreAdminReportDetails('User vs Activity')" style=" cursor: pointer;">
                    <div class="reports_block">
                        <img src="../../assets/img/DMS/effectiveness_check.svg" width="16px" height="16px"
                            alt="User vs Activity">
                    </div>
                    <p class="report_subtext">User vs Activity</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4" *ngIf="isQMS">
                <div class="d-flex gap-2 align-items-center report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'QMS User Group'}"
                    (click)="moreAdminReportDetails('QMS User Group')"
                    (keydown.enter)="moreAdminReportDetails('QMS User Group')" style=" cursor: pointer;">
                    <div class="reports_block">
                        <i class="fa-solid fa-certificate" style="color: #fbfcfe;"></i>
                    </div>
                    <p class="report_subtext">QMS User Group</p>
                </div>
            </div>
            <div class="col-md-4" *ngIf="!isQMS"></div>

            <div class="col-md-4" *ngIf="isTRN">
                <div class="d-flex gap-2 align-items-center report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'TMS User Group'}"
                    (click)="moreAdminReportDetails('TMS User Group')"
                    (keydown.enter)="moreAdminReportDetails('TMS User Group')" style=" cursor: pointer;">
                    <div class="reports_block">
                        <img src="../../assets/img/user (4).png" width="16px" height="16px" alt="TMS User Group">
                    </div>
                    <p class="report_subtext">TMS User Group</p>
                </div>
            </div>
            <div class="col-md-4" *ngIf="!isTRN"></div>

            <div class="col-md-4" *ngIf="isDMS">
                <div class="d-flex gap-2 align-items-center report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'DMS User Group'}"
                    (click)="moreAdminReportDetails('DMS User Group')"
                    (keydown.enter)="moreAdminReportDetails('DMS User Group')" style=" cursor: pointer;">
                    <div class="reports_block">
                        <img src="../../assets/img/folder (3).png" width="16px" height="16px" alt="DMS User Group">
                    </div>
                    <p class="report_subtext">DMS User Group</p>
                </div>
            </div>
            <div class="col-md-4" *ngIf="!isDMS"></div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="d-flex gap-2 align-items-center report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'Switch User Log'}"
                    (click)="moreAdminReportDetails('Switch User Log')"
                    (keydown.enter)="moreAdminReportDetails('Switch User Log')" style=" cursor: pointer;">
                    <div class="reports_block">
                        <img src="../../assets/img/switchReport.png" width="16px" height="16px" alt="Switch User Log">
                    </div>
                    <p class="report_subtext">Switch User Log</p>
                </div>
            </div>

            <div class="col-md-4">
                <div class="d-flex gap-2 align-items-center  report"
                    [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User Login'}"
                    (click)="moreAdminReportDetails('User Login')"
                    (keydown.enter)="moreAdminReportDetails('User Login')" style=" cursor: pointer;">
                    <div class="reports_block">
                        <img src="../../assets/img/user (3).png" width="16px" height="16px" alt="User Login">
                    </div>
                    <p class="report_subtext">User Login</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="d-flex gap-2 align-items-center  report">
                    <div class="">

                    </div>
                    <p class="report_subtext"></p>
                </div>
            </div>
        </div>
    </div>
</div>
<hr>
<div class="row" *ngIf="showCharts">
    <div class="d-flex gap-5 ">
        <div class="col-md-4 border rounded-4 p-2 mb-3 " *ngIf="userList1.length>0 ">
            <app-simple-chart [options]="chartOptionsForUserStatus" (dblclick)="adminChartDoubleClick(1)" />
            <!-- <div echarts [options]="chartOptionsForUserStatus" (chartClick)="onChartClick($event)"
                class="chart-container">
            </div> -->
            <!-- <canvasjs-chart [options]="chartOptionsForUserStatus" [styles]="{width: '100%', height:'220px'}"
                (dblclick)="adminChartDoubleClick(1)"></canvasjs-chart> -->
        </div>
        <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="userList1.length == 0">
            <label for=" "
                style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>Status</b></label>
            <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
                <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
        </div>

        <div class="col-md-4 border rounded-4 p-2 mb-3 " *ngIf="userList.length>0 ">
            <canvasjs-chart [options]="chartOptionsForConcurentUser" [styles]="{width: '100%', height:'220px'}"
                (dblclick)="adminChartDoubleClick(2)"></canvasjs-chart>
        </div>
        <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="userList.length == 0 ">
            <label for=" "
                style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>Status</b></label>
            <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
                <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
        </div>
        <div class="col-md-4 border rounded-4 p-2 mb-3 " *ngIf="UserLoginInactivityList.length>0 ">
            <canvasjs-chart [options]="chartOptionsForUserLoginInactivity" [styles]="{width: '100%', height:'220px'}"
                (dblclick)="adminChartDoubleClick(3)"></canvasjs-chart>
        </div>
        <div class="col-md-4 border rounded-4 p-2 mb-3" *ngIf="UserLoginInactivityList.length == 0 ">
            <label for=" "
                style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>User
                    Login Inactivity</b></label>
            <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
                <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
        </div>
    </div>
    <div class="d-flex gap-5 ">
        <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="departmentList.length > 0 ">
            <app-simple-chart [options]="chartOptionsForDepartment" (dblclick)="adminChartDoubleClick(4)" />

            <!-- <canvasjs-chart [options]=" chartOptionsForDepartment" [styles]="{width: '100%', height:'220px'}"
                (dblclick)="adminChartDoubleClick(4)"></canvasjs-chart> -->
        </div>
        <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="departmentList.length == 0 ">
            <label for=" "
                style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>Status</b></label>
            <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
                <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
        </div>
        <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="designationList.length > 0 ">
            <canvasjs-chart [options]="chartOptionsForDesignation" [styles]="{width: '100%', height:'220px'}"
                (dblclick)="adminChartDoubleClick(5)"></canvasjs-chart>
        </div>
        <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="designationList.length == 0 ">
            <label for=" "
                style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>Status</b></label>
            <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
                <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
        </div>
    </div>
    <div class="d-flex gap-5 ">
        <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="timeZoneList.length > 0 ">
            <canvasjs-chart [options]="chartOptionsForTimeZone" [styles]="{width: '100%', height:'220px'}"
                (dblclick)="adminChartDoubleClick(6)"></canvasjs-chart>
        </div>
        <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="timeZoneList.length == 0 ">
            <label for=" "
                style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>Status</b></label>
            <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
                <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
        </div>
        <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="allGroupCount.length > 0 ">
            <canvasjs-chart [options]="chartOptionsForGroup" [styles]="{width: '100%', height:'220px'}"
                (dblclick)="adminChartDoubleClick(7)"></canvasjs-chart>
        </div>
        <div class="col-md-6 border rounded-4 p-2 mb-3" *ngIf="allGroupCount.length == 0 ">
            <label for=" "
                style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins', sans-serif;color:#0F3659;"><b>Status</b></label>
            <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
                <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
        </div>
    </div>
</div>
<ng-template #reportPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle">{{clickedType}} : {{clickedVal}}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="row" *ngIf="clickedStageStatusVal!=''">
        <div class="col-md-3"></div>
        <div class="col-md-6">
            <canvasjs-chart [options]="chartOptionsForStagesStatus"
                [styles]="{width: '100%', height:'250px'}"></canvasjs-chart>
        </div>
    </div>
    <div class="table-container" *ngIf="showReportFlagValue=='1' || showReportFlagValue=='3'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>User Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('userName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>User Full Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('firstName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is AD User</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('isAdUser', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Designation</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('designation', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Department</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('department', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Manager Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('managerName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Email Address</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('emailAddress', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Contact Number</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('contactNumber', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>City</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('city', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Time Zone</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('timezone', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('isActive', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is User Deactivated</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('isUserDeactivated', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('createdOnStr', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Created By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('createdByUser', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Updated On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('updatedOnStr', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Updated By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('updatedByUser', $event,'s')" />
                        </div>
                    </th>
                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.userName }}</td>
                    <td class="row-data">{{ listOfUsersData.lastName }},{{ listOfUsersData.firstName }}</td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isAdUser === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isAdUser === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.designation }}</td>
                    <td class="row-data">{{ listOfUsersData.department }}</td>
                    <td class="row-data">{{ listOfUsersData.managerName }}</td>
                    <td class="row-data">{{ listOfUsersData.emailAddress }}</td>
                    <td class="row-data">{{ listOfUsersData.contactNumber }}</td>
                    <td class="row-data">{{ listOfUsersData.city }}</td>
                    <td class="row-data">{{ listOfUsersData.timezone }}</td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isActive === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isUserDeactivated === 'Y'"
                                src="../../assets/img/accessSymbol.svg" width="20" height="20"
                                alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isUserDeactivated === 'N'"
                                src="../../assets/img/noAcessSymbol.svg" width="20" height="20"
                                alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
                    <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
                </tr>
            </table>
        </div>

        <div class="d-flex justify-content-center">
            <div class="width-cheat small paginationCell">
                <div class="d-flex align-items-center gap-3">
                    <div class="pagination_text mt-3">
                        {{ showingRowsText }}
                        1-{{ perPage }} of {{ collectionSize | number }}
                    </div>
                    <div>
                        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)"
                            [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                            [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                            [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                    </div>
                    <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                            {{ perPage }}
                            <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                        </div>
                        per page
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="table-container" *ngIf="showReportFlagValue=='4' && typeOfGroup=='TMS'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>Group Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('groupName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Group Description</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('groupDescription', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>CC Reminder Email To Rm</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('ccReminderEmailToRm', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('isActive', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Addl Due Reminder Emails</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('addlDueReminderEmails', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Addl Due Escalation Emails</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('addlDueEscalationEmails', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Max Attempt Escalation Emails</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('maxAttemptEscalationEmails', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('createdByUser', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('createdOnStr', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Updated By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('updatedByUser', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>updated On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('updatedOnStr', $event,'d')" />
                        </div>
                    </th>
                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.groupName }}</td>
                    <td class="row-data">{{ listOfUsersData.groupDescription }}</td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.ccReminderEmailToRm === 'Y'"
                                src="../../assets/img/accessSymbol.svg" width="20" height="20"
                                alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.ccReminderEmailToRm === 'N'"
                                src="../../assets/img/noAcessSymbol.svg" width="20" height="20"
                                alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isActive === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.addlDueReminderEmails }}</td>
                    <td class="row-data">{{ listOfUsersData.addlDueEscalationEmails }}</td>
                    <td class="row-data">{{ listOfUsersData.maxAttemptEscalationEmails }}</td>
                    <td class="row-data">{{ listOfUsersData.createdByUser}}</td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
                    <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
                </tr>
            </table>
        </div>
        <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                    [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
                <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                        {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic">
                        <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                    </div>
                    per page
                </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
        </div>
    </div>
    <div class="table-container" *ngIf="showReportFlagValue=='4' && typeOfGroup=='DMS'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>Group Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('groupName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Group Description</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('groupDescription', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('isActive', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('createdOn', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Created By </span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('createdByUser', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Updated On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('updatedOn', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Updated By </span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('updatedByUser', $event,'s')" />
                        </div>
                    </th>
                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.groupName }}</td>
                    <td class="row-data">{{ listOfUsersData.groupDescription }}</td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isActive === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
                    <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
                </tr>
            </table>
        </div>
        <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                    [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
                <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                        {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic">
                        <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                    </div>
                    per page
                </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
        </div>
    </div>
    <div class="table-container" *ngIf="showReportFlagValue=='4' && typeOfGroup=='QMS'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>Group Code</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('groupCode', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Group Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('groupName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Group Description</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('groupDescription', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Modules</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('modules', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('isActive', $event,'s')" />
                        </div>
                    </th>

                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('createdOnStr', $event,'d')" />
                        </div>
                    </th>

                    <th>
                        <span>Created By </span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('createdByUser', $event,'s')" />
                        </div>
                    </th>

                    <th>
                        <span>Updated On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('updatedOnStr', $event,'d')" />
                        </div>
                    </th>

                    <th>
                        <span>Updated By </span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter('updatedByUser', $event,'s')" />
                        </div>
                    </th>
                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.groupCode }}</td>
                    <td class="row-data">{{ listOfUsersData.groupName }}</td>
                    <td class="row-data">{{ listOfUsersData.groupDescription }}</td>
                    <td class="row-data">{{ listOfUsersData.modules }}</td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isActive === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
                    <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
                </tr>
            </table>
        </div>
        <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                    [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
                <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                        {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic">
                        <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                    </div>
                    per page
                </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
        </div>
    </div>
    <div class="table-container" *ngIf="showReportFlagValue=='2'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>User Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('userName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>User Full Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('firstName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Designation</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('designation', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Department</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('department', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Email Address</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('emailAddress', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Country</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('countryName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>City</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('city', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Time Zone</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('timezone', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('createdOnStr', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Last Logon Date</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('lastLogonDateStr', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Last Logon Before</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter1('lastLogonBefore', $event,'s')" />
                        </div>
                    </th>
                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems1.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.userName }}</td>
                    <td class="row-data">{{ listOfUsersData.lastName }},{{ listOfUsersData.firstName }}</td>
                    <td class="row-data">{{ listOfUsersData.designation }}</td>
                    <td class="row-data">{{ listOfUsersData.department }}</td>
                    <td class="row-data">{{ listOfUsersData.emailAddress }}</td>
                    <td class="row-data">{{ listOfUsersData.countryName }}</td>
                    <td class="row-data">{{ listOfUsersData.city }}</td>
                    <td class="row-data">{{ listOfUsersData.timezone }}</td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
                    <td class="row-data">{{ listOfUsersData.lastLogonDateStr }}</td>
                    <td class="row-data">{{ listOfUsersData.lastLogonBefore }}</td>
                </tr>
            </table>
        </div>
        <div class="d-flex justify-content-center">
            <div class="width-cheat small paginationCell">
                <div class="d-flex align-items-center gap-3">
                    <div class="pagination_text mt-3">
                        {{ showingRowsText }}
                        1-{{ perPage }} of {{ collectionSize | number }}
                    </div>
                    <div>
                        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)"
                            [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                            [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                            [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                    </div>
                    <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                            {{ perPage }}
                            <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
                            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
                            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
                        </div>
                        per page
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #reportPopupForZoom>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopupForZoomFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"></label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="row">
        <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal==1">
            <canvasjs-chart [options]="chartOptionsForUserStatusZoom"
                [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal==2">
            <canvasjs-chart [options]="chartOptionsForConcurentUserZoom"
                [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal==3">
            <canvasjs-chart [options]="chartOptionsForUserLoginInactivityZoom"
                [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal==4">
            <canvasjs-chart [options]="chartOptionsForDepartmentZoom"
                [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal==5">
            <canvasjs-chart [options]="chartOptionsForDesignationZoom"
                [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal==6">
            <canvasjs-chart [options]="chartOptionsForTimeZoneZoom"
                [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 border rounded-4 p-2 mb-3" *ngIf="clickedChartVal==7">
            <canvasjs-chart [options]="chartOptionsForGroupZoom"
                [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
        </div>
    </div>
    <div class="table-container" *ngIf="showReportFlagValueTotal=='6' || showReportFlagValueTotal=='8'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>User Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('userName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>User Full Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('firstName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is AD User</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('isAdUser', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Designation</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('designation', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Department</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('department', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Manager Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('managerName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Email Address</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('emailAddress', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Contact Number</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('contactNumber', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>City</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('city', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Time Zone</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('timezone', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('isActive', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('createdOnStr', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Created By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('createdByUser', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Updated On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('updatedOnStr', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Updated By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('updatedByUser', $event,'s')" />
                        </div>
                    </th>
                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems5.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.userName }}</td>
                    <td class="row-data">{{ listOfUsersData.lastName }},{{ listOfUsersData.firstName }}</td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isAdUser === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isAdUser === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.designation }}</td>
                    <td class="row-data">{{ listOfUsersData.department }}</td>
                    <td class="row-data">{{ listOfUsersData.managerName }}</td>
                    <td class="row-data">{{ listOfUsersData.emailAddress }}</td>
                    <td class="row-data">{{ listOfUsersData.contactNumber }}</td>
                    <td class="row-data">{{ listOfUsersData.city }}</td>
                    <td class="row-data">{{ listOfUsersData.timezone }}</td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isActive === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
                    <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
                </tr>
            </table>
        </div>
        <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>

            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                    [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
                <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                        {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
                        <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
                    </div>
                    per page
                </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
        </div>
    </div>
    <div class="table-container" *ngIf="showReportFlagValueTotal=='9' && typeOfGroup=='TMS'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>Group Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('groupName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Group Description</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('groupDescription', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>CC Reminder Email To Rm</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('ccReminderEmailToRm', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('isActive', $event,'s')" />
                        </div>
                    </th>

                    <th>
                        <span>Addl Due Reminder Emails</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('addlDueReminderEmails', $event,'s')" />
                        </div>
                    </th>

                    <th>
                        <span>Addl Due Escalation Emails</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('addlDueEscalationEmails', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Max Attempt Escalation Emails</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('maxAttemptEscalationEmails', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('createdByUser', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('createdOnStr', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Updated By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('updatedByUser', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>updated On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('updatedOnStr', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Update Reason</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('updateReason', $event,'s')" />
                        </div>
                    </th>
                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems5.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.groupName }}</td>
                    <td class="row-data">{{ listOfUsersData.groupDescription }}</td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.ccReminderEmailToRm === 'Y'"
                                src="../../assets/img/accessSymbol.svg" width="20" height="20"
                                alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.ccReminderEmailToRm === 'N'"
                                src="../../assets/img/noAcessSymbol.svg" width="20" height="20"
                                alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isActive === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.addlDueReminderEmails }}</td>
                    <td class="row-data">{{ listOfUsersData.addlDueEscalationEmails }}</td>
                    <td class="row-data">{{ listOfUsersData.maxAttemptEscalationEmails }}</td>
                    <td class="row-data">{{ listOfUsersData.createdByUser}}</td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
                    <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.updateReason }}</td>
                </tr>
            </table>
        </div>
        <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>

            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                    [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
                <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                        {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
                        <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
                    </div>
                    per page
                </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
        </div>
    </div>
    <div class="table-container" *ngIf="showReportFlagValueTotal=='9' && typeOfGroup=='DMS'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>Group Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('groupName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Group Description</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('groupDescription', $event,'s')" />
                        </div>
                    </th>

                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('isActive', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('createdOnStr', $event,'d')" />
                        </div>
                    </th>

                    <th>
                        <span>Created By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('createdByUser', $event,'s')" />
                        </div>
                    </th>

                    <th>
                        <span>Updated On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('updatedOnStr', $event,'d')" />
                        </div>
                    </th>

                    <th>
                        <span>Updated By</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('updatedByUser', $event,'s')" />
                        </div>
                    </th>

                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems5.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.groupName }}</td>
                    <td class="row-data">{{ listOfUsersData.groupDescription }}</td>
                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isActive === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
                    <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
                </tr>
            </table>
        </div>
        <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                    [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
                <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                        {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
                        <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
                    </div>
                    per page
                </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
        </div>
    </div>
    <div class="table-container" *ngIf="showReportFlagValueTotal=='9' && typeOfGroup=='QMS'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;
        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>Group Code</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('groupCode', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Group Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('groupName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Group Description</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('groupDescription', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Modules</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('modules', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Is Active</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('isActive', $event,'s')" />
                        </div>
                    </th>

                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('createdOnStr', $event,'d')" />
                        </div>
                    </th>

                    <th>
                        <span>Created By </span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('createdByUser', $event,'s')" />
                        </div>
                    </th>

                    <th>
                        <span>Updated On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('updatedOnStr', $event,'d')" />
                        </div>
                    </th>

                    <th>
                        <span>Updated By </span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter5('updatedByUser', $event,'s')" />
                        </div>
                    </th>

                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems5.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.groupCode }}</td>
                    <td class="row-data">{{ listOfUsersData.groupName }}</td>
                    <td class="row-data">{{ listOfUsersData.groupDescription }}</td>
                    <td class="row-data">{{ listOfUsersData.modules }}</td>

                    <td class="row-data">
                        <div class="icon-container">
                            <img *ngIf="listOfUsersData.isActive === 'Y'" src="../../assets/img/accessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                            <img *ngIf="listOfUsersData.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20" alt="Access granted symbol">
                        </div>
                    </td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
                    <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
                </tr>
            </table>
        </div>
        <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                    [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
                <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                        {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
                        <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
                    </div>
                    per page
                </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
        </div>
    </div>

    <div class="table-container" *ngIf="showReportFlagValueTotal=='7'">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div>&nbsp;&nbsp;

        <div class="table-container">
            <table style="height: 60vh;">
                <thead>
                    <th>
                        <span>User Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('userName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>User Full Name</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('firstName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Designation</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('designation', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Department</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('department', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Email Address</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('emailAddress', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Country</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('countryName', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>City</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('city', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Time Zone</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('timezone', $event,'s')" />
                        </div>
                    </th>
                    <th>
                        <span>Created On</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('createdOn', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Last Logon Date</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('lastLogonDate', $event,'d')" />
                        </div>
                    </th>
                    <th>
                        <span>Last Logon Before</span>
                        <span class="fa-solid fa-filter"></span>
                        <div class="row-search-container">
                            <input type="text" class="form-control" placeholder="Search"
                                (input)="applyFilter6('lastLogonBefore', $event,'s')" />
                        </div>
                    </th>
                    <th class="sticky-col first-col"></th>
                </thead>
                <tr *ngIf="pagedItems6.length === 0">
                    <td class="row-data text-center" colspan="15">No records found</td>
                </tr>
                <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems6; let idx = index;">
                    <td class="row-data">{{ listOfUsersData.userName }}</td>
                    <td class="row-data">{{ listOfUsersData.lastName }},{{ listOfUsersData.firstName }}</td>
                    <td class="row-data">{{ listOfUsersData.designation }}</td>
                    <td class="row-data">{{ listOfUsersData.department }}</td>
                    <td class="row-data">{{ listOfUsersData.emailAddress }}</td>
                    <td class="row-data">{{ listOfUsersData.countryName }}</td>
                    <td class="row-data">{{ listOfUsersData.city }}</td>
                    <td class="row-data">{{ listOfUsersData.timezone }}</td>
                    <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
                    <td class="row-data">{{ listOfUsersData.lastLogonDateStr}}</td>
                    <td class="row-data">{{ listOfUsersData.lastLogonBefore }}</td>
                </tr>
            </table>
        </div>
        <div class="d-flex justify-content-center">
            <div class="width-cheat small paginationCell">
                <div class="d-flex align-items-center gap-3">
                    <div class="pagination_text mt-3">
                        {{ showingRowsText }}
                        1-{{ perPage }} of {{ collectionSize | number }}
                    </div>
                    <div>
                        <ngb-pagination class="leftpadding" (pageChange)="setPage6(pager.currentPage,$event)"
                            [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                            [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                            [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                    </div>
                    <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic6"
                            ngbDropdownToggle>
                            {{ perPage }}
                            <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic6">
                            <button ngbDropdownItem (click)="paginationCall6(10)">10</button>
                            <button ngbDropdownItem (click)="paginationCall6(20)">20</button>
                            <button ngbDropdownItem (click)="paginationCall6(50)">50</button>
                        </div>
                        per page
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupForZoomFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
    <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
        <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="align-center">
        <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title
            }}
            ?</label>
    </div>
    <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
        <label for="email" style="font-size: .7rem; font-weight: bold;">
            <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
            <span *ngIf="manuallyPicked && maxCountReached">
                We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
            </span>
        </label>
    </div>
    <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
        <div class="col-md-12" *ngIf="selectedColumns.length">
            <div><label for="email">Selected Column(s)</label></div>
            <textarea id="selectedValuesTextarea" class="input-filed-textarea"
                style="margin-top: 8px; cursor: not-allowed;" rows="4" cols="50" [disabled]="true"
                [(ngModel)]="selectedColumnsAsString"></textarea>
        </div>
        <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
            <div class="col-md-6">
                <label for="radio">PDF Page Size</label>
                <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
                    <mat-radio-button *ngFor="let data of pdfPageSizes"
                        [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-md-6" style="margin-top: 1.5%;">
                <label for="toggle">Pick Columns Manually?</label>&nbsp;
                <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked"
                    id="toggle">
                    <ng-container *ngIf="manuallyPicked; else no">
                        <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #no>
                        <span style="color: red;">No</span>
                    </ng-template>
                </mat-slide-toggle>
            </div>
        </div>
        <div class="row mt-3" *ngIf="manuallyPicked">
            <div class="col-md-12">
                <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
                <mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
                    (closed)="pdfSearchText=''" (click)="focusSearch('focus-department-search')"
                    (keydown.enter)="focusSearch('focus-department-search')">
                    <input type="search" id="focus-department-search" class="dropdownsearchstyle"
                        [(ngModel)]="pdfSearchText" matInput placeholder="search">
                    <div class="select-all">
                        <mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')"> Select
                            All</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : pdfSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-sm-4">
                <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
            </div>
            <div class="col-sm-8">
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
                    (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
                    (keydown.enter)="focusSearch('focus-Logo-search')">
                    <input type="search" id="focus-footer-search" class="dropdownsearchstyle"
                        [(ngModel)]="pdfDetailSearchText" matInput placeholder="search">

                    <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                        (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-sm-4">
                <label for="email">Is Save Report?</label>
            </div>
            <div class="col-sm-8">
                <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
                    <ng-container *ngIf="isSaveReport; else noisSaveReport">
                        <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #noisSaveReport>
                        <span style="color: red;">No</span>
                    </ng-template>
                </mat-slide-toggle>
            </div>
        </div>
        <div class="row justify-content-md-center" *ngIf="isSaveReport">
            <div class="col-sm-4">
                <label for="email">Report Name</label>
            </div>
            <div class="col-sm-8">
                <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
            </div>
        </div>

    </div>
    <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
        <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
            <i class="fa fa-file-excel-o"></i> Generate
        </button>
        <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
            <i class="fa fa-file-pdf-o"></i> Generate
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>